import { Trans } from '@lingui/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiDummyButton } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useLocation, useParams } from 'react-router-dom';
import { ErrorPageWithTranslations } from '../../components/ErrorPageWithTrans';
import ContentWrapper from '../../components/Layouts/ContentWrapper';
import { NoddiLoadingScreenWithTrans } from '../../components/NoddiLoadingScreenWithTrans';
import { BgImageContainer } from '../BookingInfo/BgImageContainer';
import { CopyReferralCodeCard } from './CopyReferralCodeCard';
import { DinteroErrorTypes } from './types';
import { getErrorTextBasedOnErrorType } from './utils';

export const PaymentInfo = () => {
  const { slug } = useParams<{ slug: string }>();

  const {
    data: bookingInfo,
    isPending: isBookingInfoPending,
    error: bookingInfoError
  } = noddiAsync.useGet({
    type: URLKeys.getBookingInfo,
    input: { slug: slug! }
  });

  // const {
  //   isLoading: isDownloadingReceiptLoading,
  //   refetch: downloadReceipt,
  //   error: downloadReceiptError
  // } = noddiAsync.useGet({
  //   type: URLKeys.downloadBookingReceipt,
  //   input: {
  //     bookingId: bookingInfo?.id as number
  //   },
  //   queryConfig: {
  //     enabled: false
  //   }
  // });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const transactionId = searchParams.get('transaction_id');
  const error = searchParams.get('error') as DinteroErrorTypes;

  const isPaymentSuccessful = Boolean(transactionId) && error !== 'capture';

  if (isBookingInfoPending) {
    return <NoddiLoadingScreenWithTrans />;
  }
  if (bookingInfoError) {
    return <ErrorPageWithTranslations apiError={bookingInfoError} />;
  }

  return (
    <BgImageContainer>
      <ContentWrapper hideBackButton className='flex min-h-[60vh] items-center justify-center'>
        {isPaymentSuccessful ? (
          <div className='flex flex-col gap-6 xxs:gap-8 lg:gap-16'>
            <div className='flex flex-col gap-2'>
              <h1 className='font-bold text-7 text-darkPurple lg:text-10'>
                <Trans>Thanks, we have received your payment</Trans> 🎉
              </h1>
              {/* <NoddiButton
                loading={isDownloadingReceiptLoading}
                startIcon='Download'
                variant='secondary'
                onPress={async () => {
                  await downloadReceipt();
                }}
              >
                <Trans>Receipt</Trans>
              </NoddiButton>
              {downloadReceiptError && (
                <div className='mb-3'>
                  <ApiErrorMessageWithTrans error={downloadReceiptError} />
                </div>
              )} */}
            </div>

            <div className='flex w-full flex-col gap-6 xxs:gap-8 lg:flex-row lg:gap-16'>
              <NoddiBasicCard
                to={customerRoutes.bookingInfo.getPath({ slug: slug! })}
                className='flex w-full flex-col gap-4 text-darkPurple'
              >
                <h3 className='font-bold text-5'>
                  <Trans>How was your experience?</Trans>
                </h3>
                <span>
                  <Trans>Help us improve by sharing your thoughts</Trans>
                </span>

                {slug && (
                  <div className='flex h-full items-end'>
                    <NoddiDummyButton className='w-full'>
                      <Trans>Give feedback</Trans>
                    </NoddiDummyButton>
                  </div>
                )}
              </NoddiBasicCard>
              <CopyReferralCodeCard referralCode={bookingInfo.referralCode} />
            </div>
          </div>
        ) : (
          <NoddiBasicCard className='flex w-full flex-col items-center gap-4 text-center'>
            <span className='font-bold text-6'>
              <Trans>Payment failed</Trans>
            </span>
            <span>{getErrorTextBasedOnErrorType(error)}</span>

            <NoddiLink className='w-full' to={customerRoutes.bookingInfo.getPath({ slug: slug! })}>
              <Trans>Try again</Trans>
            </NoddiLink>
          </NoddiBasicCard>
        )}
      </ContentWrapper>
    </BgImageContainer>
  );
};
